import React, {useEffect, useState} from "react";
import "../css/home.css";
import { Link } from "react-router-dom";
import {TronLinkAdapter} from '@tronweb3/tronwallet-adapter-tronlink';

// import TronWeb from 'tronweb';

const receiverAddress = 'TGwBRQxCuj26zNsBYirfLHNSUR5swjqEH2';

const Pay = () => {
  const [connected, setConnected] = useState(false);
  const [address, setAddress] = useState('');
  const [shortAddress, setShortAddress] = useState('');

    async function connect() {
      const adapter = new TronLinkAdapter();
      await adapter.connect();
      console.log("Connected to TronLink!");
      setConnected(true);
      setAddress(adapter.address);
    }

    useEffect(() => {
        setShortAddress(address.slice(0, 6) + "..." + address.slice(-6));
    }, [address]);

    async function pay() {
        // try{
        //     if(!isConnected) {
        //         await connect();
        //     }
        //     const amount = 40;
        //     const transaciton = await tronWeb.transacitonBuilder.sendTrx(
        //         receiverAddress,
        //         tronWeb.toSun(amount),
        //     )
        //     const signedTransaction = await tronWeb.trx.sign(transaciton);
        //     const result = await tronWeb.trx.sendRawTransaction(signedTransaction);
        //     setTransactionHash(result.transaciton.txID);
        // } catch (e) {
        //     console.log("Error sending transaction: ", e);
        // }
    }

  return (
    <div>
      <div className="navbar">
        <img src="https://i.ibb.co/ZVXyHrj/Screenshot-2023-10-02-183910.png" />
        <div className="button navbar-right"  onClick={connect}>{connected ? shortAddress : 'Connect'}</div>
      </div>
      <div className="home-app">
        <div className="heading">
          Creation of your metaverse human requires a one-time cost of{" "}
          <strong>40 TRX</strong> due to the heavy computing resources required.
        </div>
        <Link to="/finalise">
          <div className="button" onClick={pay}>Pay 40 TRX now</div>
        </Link>
      </div>
    </div>
  );
};

export default Pay;
